import {Component, OnInit} from '@angular/core';
import {FinanceService} from '../../../services/api/finance.service';
import {ModalService} from '../../../services/modal/modal.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {AlertService} from '../../../services/notify/alert.service';
import {TranslateService} from '@ngx-translate/core';
import {FinanceWalletModel, ForecastModel} from '../../../models/finance.model';

@Component({
    selector: 'app-personal-finance',
    templateUrl: './personal-finance.component.html',
    styleUrls: ['./personal-finance.component.scss']
})
export class PersonalFinanceComponent implements OnInit {

    public wallets: FinanceWalletModel[];
    public forecasts: ForecastModel[] = [];
    public isLoadingData = false;
    public isLoadingDataError = false;
    public masterWallet: FinanceWalletModel | undefined
    public flowProjection: ForecastModel

    constructor(
        public modalService: ModalService,
        private alertService: AlertService,
        private walletService: FinanceService,
        private translate: TranslateService,
    ) {
    }

    ngOnInit(): void {
        this.getWallets();
    }

    getWallets(): void {
        this.isLoadingDataError = false;
        this.isLoadingData = true;
        this.walletService.getAllPrivateWallets().subscribe({
            next: res => {
                this.masterWallet = res.wallets.find(el => el.is_master)
                this.wallets = res.wallets.filter(el => el.is_master === false);
                this.getForecasts();
                this.isLoadingData = false;
            }, error: err => {
                this.isLoadingData = false;
                this.isLoadingDataError = true;
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    getForecasts(): void {
        this.walletService.getForecastPrivateWallets().subscribe(res => {
            this.forecasts = res.forecast.forecast_wallets;
            this.flowProjection = res.forecast.forecast_total
        });
    }

    onCreateWallet(walletTitle: string, modal: NgbModalRef): void {
        if (!walletTitle) {
            this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_WALLET'), 'blue');
        } else {
            const data = {
                title: walletTitle,
                currency_code: 'RUB'
            };
            this.walletService.createPrivateWallet(data).subscribe({
                next: _ => {
                    this.getWallets();
                    this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                    modal.close();
                }, error: err => {
                    this.alertService.setAlert(err.message, 'blue');
                },
            });
        }
    }
}
